import React, { Component } from 'react';

import ResourceCategoriesAccordion from 'containers/ResourceCategoriesAccordion';
import AccordionItem from 'components/Accordion/AccordionItem';
import './style.scss';

class MagazineCategories extends Component {

  renderTopic(topic, countInfo) {
    return (
      <AccordionItem
        isForMagazine
        key={topic.id}
        title={topic.title}
        countInfo={countInfo(topic)}
        url={`/magazine?topic=${topic.id}`}
      />
    );
  }

  render() {
    return (
      <div className="MagazineCategories wrapper-full is-collapsed is-collapsed-top has-background" ref="wrapper">
        <div className="wrapper-small is-padded-top">
          <h1>{__('members.magazine.titles.categories')}</h1>
          <ResourceCategoriesAccordion
            isForMagazine
            resourceType="articles"
            resourceNameSingular={__('entities.articles.singular')}
            resourceNamePlural={__('entities.articles.plural')}
            renderTopic={this.renderTopic}
            scrollElementGetter={() => this.refs.wrapper.parentElement}
            />
        </div>
      </div>
    );
  }
}

export default MagazineCategories;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Magazine/MagazineCategories/index.js
 **/